/* eslint import/no-webpack-loader-syntax: off */

import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import pluralize from 'pluralize';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import amazonLogo from '../storage/amazon-com-light.svg';

import { ITEM_IMG_URL, DOWNLOADS_URL, AMAZON_BASE_URL } from '../config';

import { postCartData } from '../actions/carts';
import { updateLocalCart } from '../actions/local-cart';

import { formatCurrency } from '../scripts/functions';
// import { addImpression } from '../scripts/tracking';

// import './styling/ItemData.css';

/* eslint react/no-danger: 0 */

const styles = {
    nav: {
        width: 150,
        margin: '0 0 2em',
    },
    button: {
        position: 'absolute',
        bottom: 40,
        left: '50%',
        transform: 'translateX(-50%)',
    },
};

class ItemData extends React.Component {
    state = {
        photo: 0,
        zoom: false,
        showData: 'description',
        quantity: 1,
        inCart: false,
    };

    componentDidMount = () => {
        const { item, cartQuantity } = this.props;
        const { sku } = item;

        if (cartQuantity) {
            this.setState({ quantity: cartQuantity });
        }

        this.checkCart(sku);
    };

    componentDidUpdate = () => this.checkCart();

    checkCart = (sku) => {
        const { cart, localCart } = this.props;
        const { inCart } = this.state;

        if (cart) {
            const currentCartItem = cart.contents.find(
                (cartItem) => cartItem.item.sku === sku
            );

            if (currentCartItem && !inCart) {
                const { quantity } = currentCartItem;
                return this.setState({ quantity, inCart: true });
            }
        } else if (localCart && !inCart) {
            const currentLocalCartItem = localCart.find(
                (cartItem) => cartItem.item.sku === sku
            );

            if (localCart.find((cartItem) => cartItem.item.sku === sku)) {
                const { quantity } = currentLocalCartItem;
                return this.setState({ quantity, inCart: true });
            }
        }

        return false;
    };

    handleUpdateQuantity = (e) => {
        const { inCart } = this.state;
        const newQuantity = e.target.value;

        this.setState({ quantity: newQuantity }, () => {
            if (inCart) {
                this.addToCart();
            }
        });
    };

    addToCart = () => {
        const { item, dispatch, loggedIn, itemCategories } = this.props;
        const quantity = parseInt(this.quantity.value, 10);
        const categoryString = (itemCategories || [])
            .map((category) => (category || {}).name)
            .join('/');

        if (loggedIn) {
            dispatch(
                postCartData({ ...item, category: categoryString }, quantity)
            );
        } else {
            dispatch(
                updateLocalCart({ ...item, category: categoryString }, quantity)
            );
        }

        this.setState({ open: true });
    };

    changePhoto = (amount, maximum) => {
        const { photo } = this.state;

        if (photo + amount >= 0 && photo + amount < maximum) {
            this.setState((prevState) => ({ photo: prevState.photo + amount }));
        }
    };

    zoom = () => {
        if (window.innerWidth > 600) {
            this.setState((prevState) => ({ zoom: !prevState.zoom }));
        }
    };

    generateDescription = () => {
        const { item, data } = this.props;
        const { materials } = data;
        const { description } = item;

        const json = JSON.parse(description.slice(2));

        const material = materials.find((mat) => mat.smartID === json.material);
        const { printers: relevantPrinters } = json;

        return (
            <Fragment>
                <h5 className="description-container-subheader">
                    About the Material
                </h5>
                <p className="description-container-paragraph">
                    {material.description}
                </p>
                <h5 className="description-container-subheader">
                    About the Adhesive
                </h5>
                <p className="description-container-paragraph">
                    {material.adhesiveLong}
                </p>
                <h5 className="description-container-subheader">
                    Compatibility
                </h5>
                <p className="description-container-paragraph">
                    <span>
                        These labels are manufactured in the USA by Kenco Label
                        &amp; Tag Co, LLC and are compatible with many roll-fed
                        inkjet printers, including{' '}
                    </span>
                    <span>
                        Primera, Epson, Afinia Label, Memjet, Neuralabel, Kiaro,
                        Quicklabel, SwiftColor &amp; VIPColor Label and other
                        printer brands.{' '}
                    </span>
                    <span>
                        Compatible printer models include but are not limited
                        to:{' '}
                    </span>
                    <span>{relevantPrinters.join(', ')}</span>
                    <span>.</span>
                </p>
                <p className="description-container-paragraph">
                    <span>
                        The labels offered for sale for use in Primera, Epson,
                        Afinia Label, Memjet, Neuralabel, Kiaro, Quicklabel,
                        SwiftColor, and VIPColor label printers{' '}
                    </span>
                    <span>
                        are not manufactured by, connected with, or sponsored or
                        endorsed by Primera, Epson, Afinia Label, Memjet,
                        Neuralabel, Kiaro, Quicklabel, SwiftColor, or VIPColor.{' '}
                    </span>
                    <span>
                        These labels are manufactured by Kenco. Kenco is a
                        registered trademark of Kenco Label &amp; Tag Co., LLC.
                        Kenco is a premium label manufacturer{' '}
                    </span>
                    <span>
                        and produces inkjet labels with thousands of size
                        options available in over 25 unique inkjet materials. If
                        you are not sure what labels are compatible with your
                        printer or if you are{' '}
                    </span>
                    <span>
                        not fully satisfied with your label printer or labels,
                        please give Kenco a call so we can recommend the perfect
                        Primera printer and Kenco labels for your application{' '}
                    </span>
                    <span>and printer.</span>
                </p>
                <h5 className="description-container-subheader">
                    Testing Disclaimer
                </h5>
                <p className="description-container-paragraph">
                    <span>
                        Kenco Label &amp; Tag Co., LLC recommends that you order
                        a sample roll of labels (1 roll) and thoroughly test the
                        label material,{' '}
                    </span>
                    <span>
                        adhesive, print quality, durability, and any other
                        variables that may require testing for your application.
                        If you run into any issues or questions{' '}
                    </span>
                    <span>
                        while testing, or if you want an expert to help you
                        choose the correct material for your application, please
                        give us a call at{' '}
                    </span>
                    <a href="tel:800-537-3336" className="bold blue orange">
                        800-537-3336
                    </a>
                    <span> and ask to speak with a materials expert.</span>
                </p>
            </Fragment>
        );
    };

    renderDescription = () => {
        const { item } = this.props;
        const { description } = item;

        return { __html: description };
    };

    renderPhotos = (fullImages) => {
        const { photo, zoom } = this.state;
        const { item } = this.props;

        return (
            <div className="item-data-photo-outer-container">
                <div
                    role="button"
                    className="item-data-photo-zoom"
                    onClick={() => this.zoom()}
                >
                    <i className="fas fa-search-plus" />
                </div>
                <div className="item-data-photo-inner-container">
                    {zoom ? (
                        ''
                    ) : (
                        <Fragment>
                            <div
                                role="button"
                                className="item-data-photo-arrow-left item-data-photo-arrow"
                                style={{
                                    display: `${photo > 0 ? '' : 'none'}`,
                                }}
                                onClick={() =>
                                    this.changePhoto(-1, fullImages.length)
                                }
                            >
                                <i className="far fa-arrow-alt-circle-left" />
                            </div>
                            <img
                                role="button"
                                src={`${ITEM_IMG_URL}${fullImages[photo].imageFile}`}
                                alt={item.name}
                                className="item-data-photo"
                                onClick={() => this.zoom()}
                            />
                            <div
                                role="button"
                                className="item-data-photo-arrow-right item-data-photo-arrow"
                                style={{
                                    display: `${
                                        photo < fullImages.length - 1
                                            ? ''
                                            : 'none'
                                    }`,
                                }}
                                onClick={() =>
                                    this.changePhoto(1, fullImages.length)
                                }
                            >
                                <i className="far fa-arrow-alt-circle-right" />
                            </div>
                        </Fragment>
                    )}
                    {fullImages.length > 1 && !zoom ? (
                        <span className="item-data-photo-caption">{`Image ${
                            photo + 1
                        } of ${fullImages.length}`}</span>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    };

    renderPoints = () => {
        const { item } = this.props;
        const { sellingPoints } = item;

        if (!_.isEmpty(sellingPoints)) {
            return sellingPoints.map((point, index) => (
                <li
                    key={`item-data-main-sub-list-item-${index + 0}`}
                    className="item-data-main-sub-list-item list-item"
                >
                    {point}
                </li>
            ));
        }

        return '';
    };

    renderPricing = () => {
        const { item, currentUser } = this.props;
        const { pricing, pricingType } = item;

        const customerID = currentUser ? currentUser.customerID : '';

        const customPricing = pricing.filter(
            (priceObj) => priceObj.customerID === customerID
        );
        const pricingList = !_.isEmpty(customPricing)
            ? customPricing
            : pricing
                  .filter((priceObj) => !priceObj.customerID)
                  .filter((priceObj) =>
                      pricingType ? priceObj.type === pricingType : true
                  );

        if (pricingList.length === 1) {
            return (
                <div className="item-data-pricing-pricebox-full">
                    <span>{formatCurrency(pricingList[0].price)}</span>
                </div>
            );
        }

        return pricingList.map((priceObj) => (
            <div
                key={`price-${priceObj.quantity}`}
                className="item-data-pricing-pricebox"
            >
                <span className="item-data-pricing-tier">{`${
                    priceObj.quantity
                } ${
                    ['ea.', 'ea', 'each', 'Each'].includes(item.unit)
                        ? ''
                        : pluralize(item.unit, parseInt(priceObj.quantity, 10))
                }`}</span>
                <span className="item-data-pricing-price">
                    <span className="item-data-pricing-price-amount">
                        {formatCurrency(priceObj.price)}
                    </span>
                    <span className="item-data-pricing-price-each">
                        &#8202; ea.
                    </span>
                </span>
            </div>
        ));
    };

    renderExtras = () => {
        const { showData } = this.state;
        const { item } = this.props;
        const { description, videoURL, id, downloads } = item;

        switch (showData) {
            case 'video':
                if (videoURL) {
                    return (
                        <div className="video-container">
                            <iframe
                                title={`video-${id}`}
                                width="560"
                                height="315"
                                src={`https://www.youtube.com/embed/${videoURL}?rel=0`}
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                            />
                        </div>
                    );
                }

                break;
            case 'downloads':
                if (!_.isEmpty(downloads)) {
                    return (
                        <ul className="downloads-list">
                            {downloads.map((data) => (
                                <li
                                    key={`download-${data.file}`}
                                    className="downloads-list-item"
                                >
                                    <a
                                        href={`${DOWNLOADS_URL}${data.file}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                    >
                                        <span className="download-item">
                                            {data.description}
                                        </span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    );
                }

                break;
            default:
            case 'description':
                if (description.startsWith('$')) {
                    return (
                        <div className="description-container">
                            {this.generateDescription()}
                        </div>
                    );
                }

                return (
                    <div
                        className="description-container"
                        dangerouslySetInnerHTML={this.renderDescription()}
                    />
                );
        }

        return '';
    };

    render() {
        const { history } = this.props;
        const {
            zoom,
            photo,
            showData,
            quantity: defaultQuantity,
            inCart,
        } = this.state;
        const { classes, item } = this.props;
        const {
            sku,
            name,
            images,
            description,
            weight,
            pkgDetails,
            availability,
            videoURL,
            downloads,
            path,
            amazonLink,
            mpn,
            discontinued,
            replacementItemSku,
        } = item;

        const fullImages = images.filter((image) => !image.thumbnail);
        const isPriceGunLabel = !!path.find((pth) => pth.startsWith('110.020'));

        let mpnDescription = description;
        if (mpn) {
            mpnDescription = `${mpnDescription} (MPN: ${mpn})`;
        }

        return (
            <Fragment>
                <Helmet>
                    <title>{name}</title>
                    <meta name="description" content={mpnDescription} />
                    <link
                        rel="canonical"
                        href={`https://www.kencolabel.com/products?show=${
                            path.filter((p) => !p.startsWith('0'))[0]
                        }&sku=${sku}`}
                    />
                </Helmet>
                <div
                    role="button"
                    className="zoom-box"
                    style={
                        zoom
                            ? { visibility: 'visible', opacity: 1 }
                            : { visibility: 'hidden', opacity: 0 }
                    }
                    onClick={() => this.zoom()}
                >
                    <img
                        src={`${ITEM_IMG_URL}${fullImages[photo].imageFile}`}
                        alt={item.description}
                        className="item-data-zoom-photo"
                    />
                </div>
                {discontinued && !replacementItemSku && (
                    <div className="item-page-discontinued condensed">
                        Unavailable online · Call to order
                    </div>
                )}
                {discontinued && replacementItemSku && (
                    <div className="item-page-discontinued condensed">
                        Replaced by{' '}
                        <Link to={`/item/${replacementItemSku}`}>
                            {replacementItemSku}
                        </Link>
                    </div>
                )}
                <div className="item-data-container">
                    <div className="item-data-photos item-data-subcontainer">
                        {this.renderPhotos(fullImages)}
                        {isPriceGunLabel ? (
                            <Button
                                className={classes.button}
                                color="secondary"
                                variant="contained"
                                onClick={() =>
                                    history.push(`/build/price-gun?sku=${sku}`)
                                }
                            >
                                <span>Customize</span>
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="item-data-main item-data-subcontainer">
                        <div className="item-data-subcontainer-header">
                            <h3 className="item-data-header item-data-main-header">
                                <span>PN: </span>
                                <span className="monospace">{sku}</span>
                            </h3>
                        </div>
                        <div className="item-data-main-contents">
                            <div className="item-data-main-part item-data-main-part-1">
                                <div className="item-data-main-sub-1 item-data-main-sub">
                                    <h4 className="item-data-header item-data-main-header">
                                        Features
                                    </h4>
                                    <ul className="item-data-main-sub-list list">
                                        {this.renderPoints()}
                                    </ul>
                                </div>
                            </div>
                            <div className="item-data-main-part item-data-main-part-2">
                                <h4 className="item-data-header item-data-main-header">
                                    Shipping
                                </h4>
                                <ul className="shipping-list">
                                    <li className="shipping-list-item list-item">{`${availability}.`}</li>
                                    <li className="shipping-list-item list-item">{`Weighs ${weight} ${pluralize(
                                        'lb',
                                        weight
                                    )}.`}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {!discontinued && (
                        <div className="item-data-pricing item-data-subcontainer">
                            <div className="item-data-subcontainer-header">
                                <h4 className="item-data-header item-data-pricing-header">
                                    Pricing
                                </h4>
                            </div>
                            <div className="item-data-pricing-main">
                                <span className="item-data-subtitle">
                                    {pkgDetails}
                                </span>
                                <div className="item-data-pricing-prices">
                                    {this.renderPricing()}
                                </div>
                                <form
                                    className="item-data-pricing-form"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        this.addToCart();
                                    }}
                                    style={{ position: 'relative' }}
                                >
                                    <input
                                        type="number"
                                        min={1}
                                        step={1}
                                        required
                                        value={defaultQuantity}
                                        ref={(quantity) => {
                                            this.quantity = quantity;
                                        }}
                                        className="item-data-pricing-form-input item-data-pricing-form-qty"
                                        onChange={(e) =>
                                            this.handleUpdateQuantity(e)
                                        }
                                    />
                                    {amazonLink ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={!amazonLink}
                                            style={{
                                                position: 'absolute',
                                                width: 'fit-content',
                                                right: 0,
                                                marginTop: -43,
                                                whiteSpace: 'nowrap',
                                            }}
                                            onClick={() =>
                                                window.open(
                                                    `${AMAZON_BASE_URL}${amazonLink}`
                                                )
                                            }
                                        >
                                            <img
                                                src={amazonLogo}
                                                alt=""
                                                style={{
                                                    height: 15,
                                                    width: 'auto',
                                                    position: 'absolute',
                                                    top: '58%',
                                                    left: '51%',
                                                    transform:
                                                        'translate(-50%, -50%)',
                                                }}
                                            />
                                            <span
                                                style={{ visibility: 'hidden' }}
                                            >
                                                Add to Cart
                                            </span>
                                        </Button>
                                    ) : (
                                        ''
                                    )}
                                    <Button
                                        type="submit"
                                        color="primary"
                                        variant="contained"
                                        ref={(submit) => {
                                            this.submit = submit;
                                        }}
                                        disabled={inCart}
                                    >
                                        <span>Add to Cart</span>
                                        {/* <span></span> */}
                                    </Button>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
                <div className="item-data-sf-container">
                    <div className="item-data-sf-labels-container">
                        <Button
                            type="submit"
                            color="primary"
                            variant="outlined"
                            onClick={() =>
                                this.setState({ showData: 'description' })
                            }
                            className={classes.nav}
                        >
                            <span>Description</span>
                        </Button>
                        {isPriceGunLabel ? (
                            <Button
                                type="submit"
                                color="primary"
                                variant="outlined"
                                onClick={() =>
                                    history.push(`/build/price-gun?sku=${sku}`)
                                }
                                className={classes.nav}
                            >
                                <span>Customize</span>
                            </Button>
                        ) : (
                            ''
                        )}
                        {videoURL ? (
                            <Button
                                type="submit"
                                color="primary"
                                variant="outlined"
                                onClick={() =>
                                    this.setState({ showData: 'video' })
                                }
                                className={classes.nav}
                            >
                                <span>Video</span>
                            </Button>
                        ) : (
                            ''
                        )}
                        {!_.isEmpty(downloads) ? (
                            <Button
                                type="submit"
                                color="primary"
                                variant="outlined"
                                onClick={() =>
                                    this.setState({ showData: 'downloads' })
                                }
                                className={classes.nav}
                            >
                                <span>Downloads</span>
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                    <div
                        className="item-data-sf-contents-container"
                        style={{ marginLeft: 5, height: 'auto' }}
                    >
                        <div className="item-data-subcontainer-header">
                            <h4 className="item-data-header item-data-sf-contents-header">
                                {showData[0].toUpperCase() + showData.substr(1)}
                            </h4>
                        </div>
                        <div className="item-data-main-part">
                            {this.renderExtras()}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(ItemData);
